/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Files_Active_Filters_SinceInputs */

const es_settings_files_active_filters_since = /** @type {(inputs: Settings_Files_Active_Filters_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desde: ${i?.date}`)
};

const en_settings_files_active_filters_since = /** @type {(inputs: Settings_Files_Active_Filters_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Since: ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Since: {date}" |
*
* @param {Settings_Files_Active_Filters_SinceInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_active_filters_since = /** @type {((inputs: Settings_Files_Active_Filters_SinceInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Active_Filters_SinceInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_active_filters_since(inputs)
	return en_settings_files_active_filters_since(inputs)
});
export { settings_files_active_filters_since as "settings.files.active_filters.since" }